import siteHeader from './components/site-header';

document.onreadystatechange = function () {
	if (document.readyState === 'interactive') {
		siteHeader();
	}
};
